export default __webpack_public_path__ + "static/media/AshleyF1.23a9821f.png";